import { LoadingButton } from "@mui/lab";
import {
    Box,
    Divider,
    Icon,
    IconButton,
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import { ChangeEvent, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SaleStatus } from "../../../api/psc";
import { AppDatePicker, MultiSelect } from "../../../components/exports";
import { SaleStatusConstants } from "../../../constants/SaleConstants";
import { DialogContext } from "../../../contexts/DialogContext";
import { resetAndFetchSales, setSalesFilter } from "../../../slices/SalesSlice";
import { RootState } from "../../../slices/Store";

export default function SalesFilter() {
    const dispatch = useDispatch();
    const saleState = useSelector((state: RootState) => state.salesState);

    const { closeDialog } = useContext(DialogContext);

    const applyFilter = () => {
        resetAndFetchSales(saleState, dispatch);
    };

    const handleSelectUser = (userIds: number[]) => {
        dispatch(setSalesFilter({ ...saleState.filter, userIds: userIds }));
    };

    const handleStatusChange = (values: SaleStatus[]) => {
        const filter = { ...saleState.filter, statuses: values };
        dispatch(setSalesFilter(filter));
    };

    const handleCreateDateFrom = (date: string) => {
        const filter = { ...saleState.filter, createDateFrom: date };
        dispatch(setSalesFilter(filter));
    };

    const handleCreateDateTo = (date: string) => {
        const filter = { ...saleState.filter, createDateTo: date };
        dispatch(setSalesFilter(filter));
    };

    const handleTermChange = (
        elem: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const filter = { ...saleState.filter, term: elem.target.value };
        dispatch(setSalesFilter(filter));
    };

    const listUserItem = saleState.users.map((u) => {
        return { id: u.id, title: u.displayName };
    });

    return (
        <Box sx={{ p: 2 }}>
            <Stack spacing={2}>
                <Stack spacing={1} direction="row" alignItems="end">
                    <Typography sx={{ flexGrow: 1 }}>
                        فیلتر فرایند های فروش
                    </Typography>

                    <LoadingButton
                        onClick={applyFilter}
                        endIcon={<Icon>filter_alt</Icon>}
                        loading={saleState.isFetching}
                        variant="contained"
                    >
                        اعمال فیلتر
                    </LoadingButton>

                    <IconButton
                        onClick={closeDialog}
                        sx={{ display: { md: "none", sm: "block" } }}
                    >
                        <Icon>close</Icon>
                    </IconButton>
                </Stack>

                <Divider />

                <MultiSelect
                    label="کاربران"
                    values={listUserItem}
                    selectedIds={saleState.filter.userIds}
                    onValueChange={handleSelectUser}
                />

                <MultiSelect
                    label="وضعیت"
                    values={SaleStatusConstants}
                    selectedIds={saleState.filter.statuses}
                    onValueChange={handleStatusChange}
                />

                <AppDatePicker
                    label="تاریخ ایجاد از"
                    onChange={handleCreateDateFrom}
                    initialValue={saleState.filter.createDateFrom}
                />

                <AppDatePicker
                    label="تاریخ ایجاد تا"
                    onChange={handleCreateDateTo}
                    initialValue={saleState.filter.createDateTo}
                />

                <TextField
                    fullWidth
                    value={saleState.filter.term}
                    onChange={handleTermChange}
                    label="جستجو"
                    placeholder={"جستجو با شناسه پروژه یا محتوای فرایند فروش"}
                    variant="outlined"
                />
            </Stack>
        </Box>
    );
}
